import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { securityService } from "services/SecurityService";
import { getException } from "lib/helpers/errorHelper";
import { User, Business } from "types";

const name: string = "user.action";
interface userState {
  user: User;
  userBusinesses: Business[];
  error: boolean;
  loading: Boolean;
  severity: string;
  showToast: boolean;
  response: any | null;
}

const initialState: userState = {
  user: {
    name: "",
    eMail: "",
    userID: 0,
    updatedBy: "",
    updatedDate: "",
    isActive: false,
    userCreation: "",
    dateCreation: "",
    groupMembers: [],
    userBusinessUnits: [],
  },
  error: false,
  response: null,
  loading: false,
  showToast: false,
  userBusinesses: [],
  severity: "success",
};

export const getUser = createAsyncThunk(`${name}/getUser`, async (userId: string, { rejectWithValue }) => {
  try {
    const response = await securityService.getUser(userId);
    return response;
  } catch ({ data }) {
    return rejectWithValue(getException(data));
  }
});

export const GetUserBusinessUnits = createAsyncThunk(
  `${name}/GetUserBusinessUnits`,
  async (email: string, { rejectWithValue }) => {
    try {
      const response = await securityService.GetUserBusinessUnits(email);
      return response;
    } catch ({ data }) {
      return rejectWithValue(getException(data));
    }
  }
);

export const createUser = createAsyncThunk(`${name}/createUser`, async (user: User, { rejectWithValue }) => {
  try {
    const response = await securityService.createUser(user);
    return response;
  } catch ({ data }) {
    return rejectWithValue(getException(data));
  }
});

export const updateUser = createAsyncThunk(`${name}/updateUser`, async (user: User, { rejectWithValue }) => {
  try {
    const response = await securityService.updateUser(user);
    return response;
  } catch ({ data }) {
    return rejectWithValue(getException(data));
  }
});

export const changeStatusUser = createAsyncThunk(
  `${name}/changeStatusUser`,
  async (user: User, { rejectWithValue }) => {
    try {
      const response = await securityService.changeStatusUser(user);
      return response;
    } catch ({ data }) {
      return rejectWithValue(getException(data));
    }
  }
);

export const userSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    /* GET USER BUSINESS UNITS */
    builder.addCase(GetUserBusinessUnits.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(GetUserBusinessUnits.fulfilled, (state, { payload }) => {
      state.error = false;
      state.loading = false;
      state.userBusinesses = payload;
    });

    builder.addCase(GetUserBusinessUnits.rejected, (state, { payload }) => {
      state.error = true;
      state.loading = false;
      state.severity = "error";
      state.response = payload;
    });
    /* GET USER */
    builder.addCase(getUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getUser.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.user = payload;
      state.severity = "success";
    });

    builder.addCase(getUser.rejected, (state, { payload }) => {
      state.error = true;
      state.loading = false;
      state.severity = "error";
      state.response = payload;
    });
    /* CREATE USER */
    builder.addCase(createUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(createUser.fulfilled, (state, { payload }) => {
      state.error = false;
      state.loading = false;
      state.showToast = true;
      state.severity = "success";
      state.response = payload;
    });

    builder.addCase(createUser.rejected, (state, { payload }) => {
      state.error = true;
      state.loading = false;
      state.showToast = true;
      state.severity = "error";
      state.response = payload;
    });
    /* UPDATE USER */
    builder.addCase(updateUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(updateUser.fulfilled, (state, { payload }) => {
      state.error = false;
      state.loading = false;
      state.showToast = true;
      state.severity = "success";
      state.response = payload;
    });

    builder.addCase(updateUser.rejected, (state, { payload }) => {
      state.error = true;
      state.loading = false;
      state.showToast = true;
      state.severity = "error";
      state.response = payload;
    });
    /* CHANGE USER STATUS */
    builder.addCase(changeStatusUser.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(changeStatusUser.fulfilled, (state, { payload }) => {
      state.error = false;
      state.loading = false;
      state.showToast = true;
      state.severity = "success";
      state.response = payload;
    });

    builder.addCase(changeStatusUser.rejected, (state, { payload }) => {
      state.error = true;
      state.loading = false;
      state.showToast = true;
      state.severity = "error";
      state.response = payload;
    });
  },
  reducers: {
    hideToast: (state) => {
      state.showToast = false;
    },
  },
});

export const { hideToast } = userSlice.actions;

export default userSlice.reducer;
